import {MOProduct} from "../types/MaterialOrderDetails";

export function calculateTotals(products: MOProduct[], taxRate?: number)
{
    const subTotal = products.reduce((a, b) => a + (b.pullFromStock ? 0 : b.unitCost * b.quantity), 0);
    const cutCharges = products.reduce((a, b) => a + b.cutCharges, 0);
    const freightCharges = products.reduce((a, b) => a + b.freightCost, 0);
    const salesTax = (taxRate ?? 0) * 100;
    const taxAmount = subTotal * (taxRate ?? 0);
    const total = subTotal + cutCharges + freightCharges + taxAmount;

    return {
        subTotal,
        cutCharges,
        freightCharges,
        taxAmount,
        salesTax,
        total
    }
}
